const queryKeys = {
	all: ["courses"],
	lists: () => [...queryKeys.all, "list"],
	list: (filters: any) => [...queryKeys.lists(), { filters }],
	details: () => [...queryKeys.all, "detail"],
	detail: (id: number) => [...queryKeys.details(), id],
	allTraining: () => [...queryKeys.all, 'training'],
	training: (user: { id: number, customerUserId?: string }) => [...queryKeys.allTraining(), user]
}

export default queryKeys
